<template>
    <div class="scroll_flex_container">
        <!-- 分類按鈕 -->
        <div class="row_center_start categories" ref="menu">
            <div v-for="(category, index) in this.categories" :key="index" @click="scrollToCategory(index)"
                :class="{ active: index === currentCategory }">
                {{ category.categoryName }}
            </div>
        </div>

        <!-- 商品區域 -->
        <div class="column_center_start products" ref="products" @scroll="handleScroll">
            <div v-for="(category, categoryIndex) in displayProductsInCategory" :key="categoryIndex"
                class="column_center_start" style="width: 100%">
                <div v-for="(product, productIndex) in category.products" :key="productIndex" class="product">
                    <Product :product="product" @click="openProductDetail(product)"
                        :cartQuantity="selectedProductQuantity(product)">
                    </Product>
                </div>
            </div>
        </div>
        <SubSummary v-if="!showProductDetail && !showComboDetail" @toOrderConfirm="toOrderConfirm"></SubSummary>
        <div>
            <ProductDetail v-if="showProductDetail" @close="closeProductDetail" :product="selectedProduct">
            </ProductDetail>
            <comboDetail v-if="showComboDetail" @close="closeComboDetail" :product="selectedProduct">
            </comboDetail>
        </div>
    </div>
</template>
<script>
import product from "@/components/store/product.vue";
import productDetail from "@/components/store/productDetail.vue";
import comboDetail from "@/components/store/comboDetail.vue";
import subSummary from "@/components/store/subSummary.vue";
import commonUtilities from "@/utils/common.utils";
import { mapGetters } from "vuex";
export default {
    components: {
        Product: product,
        ProductDetail: productDetail,
        SubSummary: subSummary,
        comboDetail
    },
    data() {
        return {
            currentCategory: 0,
            enableScroll: true,
            showProductDetail: false,
            selectedProduct: {},
            showComboDetail: false
        };
    },
    computed: {
        cart() {
            return this.$store.state.cart.cart
        },
        getCurrentStore() {
            return this.$store.state.basic.currentStore;
        },
        getUrlParameters() {
            return this.$route.params
        },
        ...mapGetters("spreadsheet", {
            categories: "categories",
            productsInCategory: "productsInCategory",
            products: 'products',
            combos: 'combos'
        }),
        ...mapGetters('userData', {
            isLogin: 'isLogin',
            isStoreMember: 'isStoreMember'
        }),
        ...mapGetters('cart', {
            areaId: 'tableAreaId',
            tableIndex: 'tableIndex'
        }),
        displayProductsInCategory() {
            return this.productsInCategory.map(group => {
                return {
                    ...group,
                    products: group.products.filter(product => {
                        if (!product) return false
                        return product.availableInStore
                    })
                }
            })
        }
    },
    async created() {
        if (!this.isLogin || !this.isStoreMember) {
            console.log('未登入或非店家會員 跳轉至首頁')
            this.$router.replace({
                path: `/${this.getCurrentStore}/store`
            })
        }
        await this.getSpreadSheetData()
    },
    methods: {
        async getSpreadSheetData() {
            const timeoutPromise = new Promise((_, reject) => 
                // 設定 30 秒超過後跳出錯誤訊息並返回上一頁
                setTimeout(() => reject(new Error('菜單讀取失敗')), 30000)
            );

            try {
                /*
                Modify By Bryant 2025061701
                commonUtilities.createLoading("資料讀取中", "請稍後");
                */
                await Promise.race([
                Promise.allSettled([
                    this.$store.dispatch('spreadsheet/getProducts'),
                    this.$store.dispatch('spreadsheet/getCombos'),
                    this.$store.dispatch('spreadsheet/getCategories'),
                    this.$store.dispatch('spreadsheet/getSpecifications'),
                    this.$store.dispatch('spreadsheet/getComboSubItems'),
                    this.$store.dispatch('spreadsheet/getComboSubAny'),
                    this.$store.dispatch('spreadsheet/getComboSubAlt'),
                    this.$store.dispatch('spreadsheet/getProductComboSpec')
                ]),
                timeoutPromise
                ]);
                console.log('餐點', this.products);
                console.log('套餐', this.combos);
                console.log('分類', this.productsInCategory);
                await this.getProductImages();
                await this.getProductDescription();
                commonUtilities.closeLoading();
            } catch (e) {
                console.error('Failed to get products:', e);
                commonUtilities.closeLoading();
                await commonUtilities.delay(300);
                commonUtilities.createToast('error', '菜單讀取失敗');
                this.$router.go(-1);
            }
        },
        async getProductImages() {
            await this.$store.dispatch('product/getProductImages')
        },
         async getProductDescription() {
            await this.$store.dispatch('product/fetchProductDescriptions')
        },
        toOrderConfirm() {
            const process = 'orderConfirm'
            const { method } = this.getUrlParameters
            let path = `/${this.getCurrentStore}/${process}/${method}/${this.areaId}/${this.tableIndex}`
            this.$router.push(path)
        },
        // 回傳有選擇商品的數量
        selectedProductQuantity(product) {
            // 購物車中可能會有重複的商品 使用 product.id 判斷相同商品 並加總 quantity
            let quantity = 0
            if (!product) return quantity
            if (!this.cart || !this.cart.length) return quantity
            for (const item of this.cart) {
                if (!item) {
                    continue
                }
                if (item.product.id === product.id) {
                    quantity += item.quantity
                }
            }
            return quantity
        },
        openProductDetail(product) {
            console.log(product)
            this.selectedProduct = product
            // 根據product 中 comboSubSettings 來決定打開 productDetail 還是 comboDetail
            if (product.comboSubSettings !== undefined) {
                this.showComboDetail = true
            } else {
                this.showProductDetail = true
            }
        },
        closeProductDetail() {
            console.log('cart', this.cart)
            commonUtilities.closeLoading()
            this.showProductDetail = false
            this.selectedProduct = {}
        },
        closeComboDetail() {
            console.log('cart', this.cart)
            commonUtilities.closeLoading()
            this.showComboDetail = false
            this.selectedProduct = {}
        },
        scrollToCategory(index) {
            const menu = this.$refs.menu;
            this.currentCategory = index;

            const productsElement = this.$refs.products;
            const targetElement = productsElement.children[index];
            const targetOffset =
                targetElement.offsetTop - menu.clientHeight - menu.offsetTop;

            // this.enableScroll = false;
            // const that = this
            // const onScroll = () => {
            //     const currentScrollTop = productsElement.scrollTop;
            //     if (currentScrollTop === targetOffset) {
            //         that.enableScroll = true;

            //         productsElement.removeEventListener("scroll", onScroll);
            //     }
            // };

            // productsElement.addEventListener("scroll", onScroll);

            productsElement.scrollTo({
                top: targetOffset,
                behavior: "instant",
            });
        },
        handleScroll() {
            const menu = this.$refs.menu;
            // 如有需要調整需求 可以在滑動時不更新選中的分類
            // if (!this.enableScroll) {
            //   return;
            // }

            const productsElement = this.$refs.products;
            const scrollPosition =
                productsElement.scrollTop + menu.clientHeight + menu.offsetTop + 10;
            let productsInCategory = [...this.displayProductsInCategory];
            productsInCategory.forEach((category, index) => {
                const categoryElement = this.$refs.products.children[index];
                productsInCategory[index].offsetTop = categoryElement.offsetTop;
            });

            let currentCategoryIndex = 0;
            for (let i = 0; i < productsInCategory.length; i++) {
                // const category = this.products[i];
                const nextCategory = productsInCategory[i + 1];

                // 檢查是否為最後一個分類，或者滾動位置在兩個分類之間
                if (
                    !nextCategory ||
                    (
                        scrollPosition < nextCategory.offsetTop)
                ) {
                    currentCategoryIndex = i;
                    break;
                } else {
                    currentCategoryIndex = i + 1;
                }
            }

            const selectedCategory = this.$refs.menu.children[currentCategoryIndex];
            const menuScrollLeft = selectedCategory.offsetLeft - (menu.clientWidth - selectedCategory.clientWidth) / 2;
            this.$refs.menu.scrollTo({
                left: menuScrollLeft,
                behavior: "instant",
            });

            // 更新選中的分類
            this.currentCategory = currentCategoryIndex;
        },
    },
};
</script>
<style lang="scss"></style>